import { Card } from "@/components/ui/card";
import { Coins } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export const TokenBalance = () => {
  const { data: tokenBalance, isLoading: isLoadingBalance } = useQuery({
    queryKey: ['tokenBalance'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('user_tokens')
        .select('token_balance')
        .single();
      
      if (error) throw error;
      return data?.token_balance ?? 0;
    },
  });

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
        <Coins className="h-6 w-6" />
        Token Balance
      </h2>
      <Card className="p-6">
        <div className="text-4xl font-bold">
          {isLoadingBalance ? "Loading..." : tokenBalance?.toLocaleString()}
        </div>
        <p className="text-muted-foreground mt-2">Available tokens</p>
      </Card>
    </div>
  );
};